

export class BranchDetailsAlertGroupInput implements IBranchDetailsAlertGroupInput {
    /** The auto-generated id of the vehicle details master */
    branchDetailId!: number;

    constructor(data?: IBranchDetailsAlertGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
        }
    }

    static fromJS(data: any): BranchDetailsAlertGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailsAlertGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        return data; 
    }
}

export interface IBranchDetailsAlertGroupInput {
    /** The auto-generated id of the vehicle details master */
    branchDetailId: number;
}

